(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/match-init-box/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/sport/match-init-box/assets/javascripts/init.js'); 
'use strict';

(function() {
  svs = svs || {};
  svs.sport = svs.sport || {};
  svs.sport.matchInitBox = svs.sport.matchInitBox || {};
  svs.sport.matchInitBox.models = svs.sport.matchInitBox.models || {};
  svs.sport.matchInitBox.views = svs.sport.matchInitBox.views || {};
})();

 })(window);